import environment from "environment";
import HttpErrorResponseModel from "models/HttpErrorResponseModel";
import ResponseAuthTokensModel from "stores/shared/models/ResponseAuthTokensModel";
import ResponseEsitoModel from "stores/shared/models/ResponseEsitoModel";
import EffectUtility from "utilities/EffectUtility";
import ExternalAuthenticateRequestModel from "./models/AccessoRequestModel";
import AccessoRequestModel from "./models/AccessoRequestModel";
import CambioPasswordRequestModel from "./models/CambioPasswordRequestModel";
import RecuperoPasswordRequestModel from "./models/RecuperoPasswordRequestModel";
import UtenteModel from "./models/UtenteModel";
import UserInfoModel from "./models/UserInfoModel";
import UserPermissionModel from "./models/UserPermissionModel";

export default class UtenteEffect {
    public static async utenteLoginGet(
        userLogin: AccessoRequestModel
    ): Promise<ResponseAuthTokensModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.utenteLoginGet;
        return EffectUtility.postToModel<ResponseAuthTokensModel>(ResponseAuthTokensModel, endpoint, userLogin);
    }

    public static async utenteGet(user: UtenteModel): Promise<UtenteModel | HttpErrorResponseModel> {
        const endpoint: string = "";
        return EffectUtility.getToModel<UtenteModel>(UtenteModel, endpoint, user);
    }

    public static async userInfoGet(user: UserInfoModel): Promise<UserInfoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.userInfo;
        return EffectUtility.getToModel<UserInfoModel>(UserInfoModel, endpoint, user);
    }

    public static async utenteRecuperoPasswordSet(
        user: RecuperoPasswordRequestModel
    ): Promise<ResponseEsitoModel | HttpErrorResponseModel> {
        const endpoint: string = "";
        return EffectUtility.postToModel<ResponseEsitoModel>(ResponseEsitoModel, endpoint, user);
    }

    public static async verificaTokenRecuperoPasswordGet(
        token: string
    ): Promise<ResponseEsitoModel | HttpErrorResponseModel> {
        const endpoint: string = "";
        return EffectUtility.getToModel<ResponseEsitoModel>(ResponseEsitoModel, endpoint, { token: token });
    }

    public static async utenteCambioPasswordSet(
        user: CambioPasswordRequestModel
    ): Promise<ResponseEsitoModel | HttpErrorResponseModel> {
        const endpoint: string = "";
        return EffectUtility.postToModel<ResponseEsitoModel>(ResponseEsitoModel, endpoint, user);
    }

    public static externalAuthenticate(
        request: ExternalAuthenticateRequestModel
    ): Promise<ResponseAuthTokensModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.authenticateExternal;
        return EffectUtility.postToModel<ResponseAuthTokensModel>(ResponseAuthTokensModel, endpoint, request);
    }

    public static async userPermissionsGet(
        user: UserPermissionModel
    ): Promise<UserPermissionModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.userRoles;
        return EffectUtility.getToModel<UserPermissionModel>(UserPermissionModel, endpoint, user);
    }

    public static logout(request: ResponseAuthTokensModel): Promise<ResponseAuthTokensModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.utenteLogout;
        return EffectUtility.postToModel<ResponseAuthTokensModel>(ResponseAuthTokensModel, endpoint, request);
    }
}
